import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'ImageSelect',
  title: [
    {
      text: 'Kliknij w obrazek, który przedstawia prawidłową postawę dziecka przy komputerze.',
      audio: 'games/page001_game2/audio/z1c2.mp3',
    },
  ],
  gameConfig: gameData,
  // checkGameSound: {
  //   positive: 'games/page001_game1/audio/z1c1-brawo.mp3',
  //   negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  // },
  // checkGameText: {
  //   positive: 'Ćwiczenie zostało wykonane. Brawo! ',
  //   negative: '',
  // },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

// console.log( 'config', config );
export default config;
